let LinkedME_KEY = 'ad166f2521335fc0adf507930af60737'
// let LinkedME_KEY = 'ad166f2521335fc0adf507930af60737'
let linkedmeType = "live";
let defaultData = {};
defaultData.type = linkedmeType;
defaultData.feature = "功能名称"; 
defaultData.stage = "阶段名称"; 
defaultData.channel = ""; 
defaultData.tags = "标签名称"; 
defaultData.ios_custom_url = ""; 
defaultData.android_custom_url = ""; 

export default function(obj) {
    if (window.linkedme.LinkedME_KEY !== LinkedME_KEY) {
        window.linkedme.init(LinkedME_KEY, { type: linkedmeType }, null);
    }
    obj = obj || {}
    let str = '';
    for (let k in obj) {
        str += `"${k}":"${obj[k]}",`
    }
    str = str.slice(0, -1)
    let params = `{${str}}`
    return new Promise((resolve, reject) => {
        window.linkedme.link({
            ...defaultData,
            ... { params: params },
        }, function(err, data) {
            let USER_Agent = navigator.userAgent;
            let is_Android = /(Android|Windows)/i;
            if (err) {
                if(is_Android.test(USER_Agent)){
                    window.location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.meishubao.client&fromcase=40002'
                }
            } else {
                if(is_Android.test(USER_Agent)){
                    // if(window.linkedme.trigger_deeplink) {
                        window.linkedme.trigger_deeplink(data.url + `&type=${obj.type}&data=${obj.data}`)
                    // } else {
                        window.location.href = data.url + `&type=${obj.type}&data=${obj.data}`
                    // }
                } else {
                    window.location.href = data.url + `&type=${obj.type}&data=${obj.data}`
                    window.linkedme.trigger_deeplink(data.url)
                    // window.location.href = 'https://lkme.cc/qq_conn/1103288394/6aoji3YyR?uid=6116002291778096'
                }
            }
        }, false);
    })
}
